/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useEffect, useState } from "react";
import Container from "common/components/Container/Container";
import i18n from "internationalization/i18n";
// import { useGetChargersQuery } from "services/chargersService";
import { userApi, useGetUsersQuery, useCreateUserMutation } from "services/userService"
import { useDispatch, useSelector } from "react-redux";
import { rootReducerType } from "../../redux/combineReducers";
import useWindowDimensions, { counterCommonItemsArrays, decodeJWT, getDataToDisplay } from "../../common/functions";
import { Button, Modal, Input, Select, DatePicker } from 'antd';
import "./Users.less";
import SelectFilter from "../../common/components/Select/Select";
import UsersTable from "../../common/components/UsersTable/UsersTable";
import { useGetStationsQuery } from "../../services/stationsService";
import { emailToUsername, getUpperCase } from "../../common/utils";
import { UserItem, PricingItem } from "services/utils/interfaces";
import Notification from "common/components/NotificationMessage/Notification";
import moment from "moment";

type Props = {
	shouldRefresh: boolean,
};

export type Users = Array<UserItem>; 
export type Pricing = Array<PricingItem>

const Users: React.FC<Props> = ({ shouldRefresh }): React.ReactElement => {
	const getFilterBy = (): string | undefined =>
		filter && [i18n.t("chargers.station"), i18n.t("chargers.type"), "Active", i18n.t("chargers.status")].includes(filter) ? filter : undefined;

	const getFilterQueryString = (
		key: string | null,
		filterBy: string | undefined,
		filterValue: string | null
	) =>
		filterBy && filterValue
			? key?.toLowerCase() + "_is_" + filterValue
			: undefined;

	const getKey = (filterBy?: string): string | null =>
		filterBy
			? (filterBy === "Station" ? "stationId" : filterBy.toLowerCase())
			: null;

	const getSortBy = (sort: string | null): string | undefined => sort ? sort : undefined;

	const { isLoggedIn } = useSelector(
		(state: rootReducerType) => state.authenticationReducer
	);

	const [limit] = useState(10);
	const [offset, setOffset] = useState<number>(0);
	const [previousOffset, setPreviousOffset] = useState<number>(offset);

	const [users, setUsers] = useState<Users>([]);

	const statusData = [
		i18n.t("chargers.available"),
		i18n.t("chargers.inUse"),
		i18n.t("chargers.unavailable"),
		i18n.t("chargers.offline"),
		i18n.t("chargers.faulted")
	];
	const typeData = [i18n.t("chargers.level2"), i18n.t("chargers.dcfc")];
	const ActiveData = ["true", "false"]
	const stations = useGetStationsQuery({
		userName: emailToUsername(decodeJWT(isLoggedIn).email)
	}).data;
	const stationData = stations ? Object.keys(stations) : [];

	const dispatch = useDispatch();

	const [filter, setFilter] = useState<string | null>(null);
	const [filterValue, setFilterValue] = useState<string | null>(null);
	const [sort, setSort] = useState<string | null>(null);
	const [reset, setReset] = useState(false);

	const { data, refetch } = useGetUsersQuery({
		userName: emailToUsername(decodeJWT(isLoggedIn).email),
		limit: String(limit),
		offset: String(offset < 0 ? 0 : offset),
		sortBy: getSortBy(sort),
		filterBy: getFilterQueryString(getKey(getFilterBy()), getFilterBy(), filterValue),
	});

	useEffect(() => {
		if (offset < previousOffset) return;
		if (offset === previousOffset) {
			const tempOffset = offset < 0 ? 0 : offset;
			dispatch(
				userApi.endpoints.getUsers.initiate(
					{
						userName: emailToUsername(decodeJWT(isLoggedIn).email),
						limit: String(limit),
						offset: String(tempOffset),
						sortBy: getSortBy(sort),
						filterBy: getFilterQueryString(getKey(getFilterBy()), getFilterBy(), filterValue),
					},
					{ subscribe: false, forceRefetch: true }
				)
			);
		}
		// setReset(false);
	}, [offset]);

	useEffect(() => {
		const tempOffset = offset <= 0 ? offset - 1 : 0;
		setOffset(tempOffset);
		setPreviousOffset(tempOffset);
	}, [filterValue, sort]);

	useEffect(() => {
		if (!data?.items) return;
		const tempOffset = offset < 0 ? 0 : offset;
		setOffset(tempOffset);
		setPreviousOffset(tempOffset);
		const counterCommonItems = counterCommonItemsArrays(data.items, users);
		const newItems = JSON.parse(JSON.stringify(
			offset <= 0
				? [...data.items]
				: (counterCommonItems === 0
					? [...users, ...data.items]
					: [...users]
				)));
		setUsers(newItems);
		setPreviousOffset(offset);
	}, [JSON.stringify(data?.items), offset, reset]);

	useEffect(() => {
		if (!reset) {
			setReset(false);
		}
		refetch();
	}, [refetch, reset]);

	useEffect(() => {
		refetch();
	}, [shouldRefresh]);

	const selectItems = [{ option: "Station" }, { option: "Active" }];

	const handleReset = () => {
		const tempOffset = offset <= 0 ? offset - 1 : 0;
		setReset(true);
		setFilter(null);
		setFilterValue(null);
		setSort(null);
		setOffset(tempOffset);
		setPreviousOffset(tempOffset);
	};

	const { width } = useWindowDimensions();

	const [loading, setLoading] = useState<boolean>(false);
	const [open, setOpen] = useState<boolean>(false);

	const handleOk = () => {
		setLoading(true);
		setTimeout(() => {
			setLoading(false);
			setOpen(false);
		}, 3000);
	};

	const handleCancel = () => {
		setOpen(false);
	};

	const [licensePlate, setLicensePlate] = useState<string>('');
	const [userName, setUserName] = useState<string>('');
	const [billingPeriod, setBillingPeriod] = useState<string>('weekly');
	const [contactNumber, setContactNumber] = useState<string>('');
	const [unitNumber, setUnitNumber] = useState<string>('');
	const [locaStationId, setLocaStationId] = useState<string>('');
	const [priorityType, setPriorityType] = useState<string>('Priority');
	const [chargePointId, setChargePointId] = useState<string>('');
	const [email, setEmail] = useState<string>('');
	const [expireAt, setExpireAt] = useState<string>('');
	const [momentTime, setMomentTime] = useState<any>('');

	const cancelTap = () => {
		setOpen(false);
	}

	const [createUser, { isSuccess: createUserSuccess, data: createUserData }] = useCreateUserMutation();

	useEffect(() => {
		if (createUserSuccess) {
			Notification({
				type: createUserData?.success ? "success" : "warning",
				message: createUserData?.success ? createUserData.message : "request failed",
				description: "",
			});
			handleCancel();
		}

	}, [createUserSuccess]);

	const saveTap = () => {
		createUser({
			licensePlate,
			userName,
			billingPeriod,
			contactNumber,
			unitNumber,
			locaStationId,
			priorityType,
			chargePointId,
			email,
			expireAt,
		});
	}

	const addUser = () => {
		setOpen(true);
	}

	const handleChangeBilling = (e) => {
		setBillingPeriod(e)
	}

	const handleChangePriority = (e) => {
		setPriorityType(e)
	}

	// 自定义日期不可用的函数
	const disabledDate = (current) => {
		// 只允许选择当前日期之后的日期
		return current && current <= currentDate.startOf('minute');
	};

	const currentDate = moment();

	const onChange = (dateString) => {
		// 'YYYY-MM-DDTHH:mm:ss'
		const newStartDate = moment(dateString).format().toString();
		setExpireAt(newStartDate);
	}

	return (
		width > 768 ? (
			<Container
				backButton={false}
				loadingPageName={i18n.t("users.pageName")}
				subTitle={i18n.t("users.subtitle")}
				renderCondition={data ? true : false}
			>
				<div className="table">
					<div className="sessions-title">
						<div>
							<SelectFilter
								selectedFilter={filter || undefined}
								selectedFilterValue={filterValue || undefined}
								setNewFilter={(value) => setFilter(value)}
								setNewFilterValue={(value) => setFilterValue(value)}
								items={selectItems}
								statusData={statusData}
								typeData={typeData}
								ActiveData={ActiveData}
								stationData={stationData}
								reset={reset}
								setReset={setReset}
							/>
							<Button onClick={handleReset} className="dark-button">Reset filters</Button>
						</div>
						<Button className="dark-button" onClick={() => addUser()}>Add User</Button>
					</div>
					{data ?
						(<UsersTable
							limit={limit}
							offset={offset < 0 ? 0 : offset}
							setOffset={setOffset}
							data={getDataToDisplay(users, limit, offset)}
							setNewSort={(value) => setSort(value)}
							shouldReset={(value) => setReset(value)}
							reset={reset}
							length={users.length + (users.length < limit ? 0 : 1)}
						/>) :
						null}
				</div>
				<Modal
					visible={open}
					title="Create a User"
					onOk={handleOk}
					onCancel={handleCancel}
					footer={[]}
					width={1000}
				>
					<div className='model-content'>
						<div className='model-content-item'>
							<p>License Plate #: </p>
							<Input style={{ width: 620 }} placeholder="License Plate"
								value={licensePlate} onChange={(e) => setLicensePlate(e.target.value)} />
						</div>
						<div className='model-content-item'>
							<p>User Name: </p>
							<Input style={{ width: 620 }} placeholder="User Name"
								value={userName} onChange={(e) => setUserName(e.target.value)} />
						</div>
						<div className='model-content-item'>
							<p>Billing Period: </p>
							<Select
								defaultValue="weekly"
								style={{ width: 620 }}
								onChange={handleChangeBilling}
								options={[
									{
										value: 'weekly',
										label: 'weekly',
									},
									{
										value: 'bimonthly',
										label: 'bimonthly',
									},
									{
										value: 'monthly',
										label: 'monthly',
									},
									{
										value: 'quarterly',
										label: 'quarterly',
									},
									{
										value: 'yearly',
										label: 'yearly',
									},
								]}
							/>
						</div>
						<div className='model-content-item'>
							<p>expireAt: </p>
							<DatePicker
								disabledDate={disabledDate}
								style={{ width: 620 }}
								showTime // 启用时间选择
								format="YYYY-MM-DD HH" // 设置日期时间格式
								placeholder="Select Date and Time"
								onChange={(value, dateString) => onChange(dateString)}
								defaultValue={momentTime}
							/>
						</div>
						{/* <div className='model-content-item'>
                    <p>expireAt: </p>
                    <DatePicker
                        disabledDate={disabledDate}
                        style={{ width: 620 }}
                        showTime // 启用时间选择
                        format="YYYY-MM-DD HH" // 设置日期时间格式
                        placeholder="Select Date and Time"
                        onChange={(value, dateString) => onChange(dateString)}
                        defaultValue={momentTime}
                    />
                </div> */}
						<div className='model-content-item'>
							<p>contact Number: </p>
							<Input style={{ width: 620 }} placeholder="contact Number"
								value={contactNumber} onChange={(e) => setContactNumber(e.target.value)} />
						</div>
						<div className='model-content-item'>
							<p>Unit Number: </p>
							<Input style={{ width: 620 }} placeholder="Unit Number"
								value={unitNumber} onChange={(e) => setUnitNumber(e.target.value)} />
						</div>
						<div className='model-content-item'>
							<p>locationId StationId: </p>
							<Input style={{ width: 620 }} placeholder="locationId StationId"
								value={locaStationId} onChange={(e) => setLocaStationId(e.target.value)} />
						</div>
						<div className='model-content-item'>
							<p>Priority: </p>
							<Select
								defaultValue="Priority"
								style={{ width: 620 }}
								onChange={handleChangePriority}
								options={[
									{
										value: 'Priority',
										label: 'Priority',
									},
									{
										value: 'regular',
										label: 'regular',
									},
								]}
							/>
						</div>
						<div className='model-content-item'>
							<p>chargePointId: </p>
							<Input style={{ width: 620 }} placeholder="chargePointId"
								value={chargePointId} onChange={(e) => setChargePointId(e.target.value)} />
						</div>
						<div className='model-content-item'>
							<p>Email address: </p>
							<Input style={{ width: 620 }} placeholder="email"
								value={email} onChange={(e) => setEmail(e.target.value)} />
						</div>
						<div className='model-last-btn'>
							<Button type="primary" danger size='large'
								style={{ margin: "10px 0", height: '50px', width: '50%', background: '#FD6B7E' }}
								onClick={() => cancelTap()}>cancel</Button>
							<Button type="primary" danger size='large'
								style={{
									background: '#FF9F39', border: '1px solid #FF9F39', height: '50px',
									width: '50%', fontSize: '20px', fontWeight: '800'
								}} onClick={() => saveTap()}>save</Button>
						</div>
					</div>
				</Modal>
			</Container>
		) : (
			<Container
				backButton={false}
				loadingPageName={i18n.t("users.pageName")}
				subTitle={i18n.t("users.subtitle")}
				renderCondition={data ? true : false}
			>
				<div style={{ display: "flex", flexDirection: "row" }}>
					<Button onClick={handleReset} className="dark-button">Reset filters</Button>
					<div style={{ marginTop: "auto", marginBottom: "auto" }}>
						<SelectFilter
							selectedFilter={filter || undefined}
							selectedFilterValue={filterValue || undefined}
							setNewFilter={(value) => setFilter(value)}
							setNewFilterValue={(value) => setFilterValue(value)}
							items={selectItems}
							statusData={statusData}
							typeData={typeData}
							stationData={stationData}
							reset={reset}
							setReset={setReset}
						/>
					</div>
					<Button className="dark-button" onClick={() => addUser()}>Add User</Button>
				</div>
				{data ?
					(
						<div style={{ marginTop: "10px" }} className="table">
							<UsersTable
								limit={limit}
								offset={offset < 0 ? 0 : offset}
								setOffset={setOffset}
								data={getDataToDisplay(users, limit, offset)}
								setNewSort={(value) => setSort(value)}
								shouldReset={(value) => setReset(value)}
								reset={reset}
								length={Users.length + (Users.length < limit ? 0 : 1)}
							/>
						</div>) :
					null}
				<Modal
					visible={open}
					title="Create a User"
					onOk={handleOk}
					onCancel={handleCancel}
					footer={[]}
					width={1000}
				>
					<div className='model-content'>
						<div className='model-content-item'>
							<p>License Plate #: </p>
							<Input style={{ width: 620 }} placeholder="License Plate"
								value={licensePlate} onChange={(e) => setLicensePlate(e.target.value)} />
						</div>
						<div className='model-content-item'>
							<p>User Name: </p>
							<Input style={{ width: 620 }} placeholder="User Name"
								value={userName} onChange={(e) => setUserName(e.target.value)} />
						</div>
						<div className='model-content-item'>
							<p>Billing Period: </p>
							<Select
								defaultValue="weekly"
								style={{ width: 620 }}
								onChange={handleChangeBilling}
								options={[
									{
										value: 'weekly',
										label: 'weekly',
									},
									{
										value: 'bimonthly',
										label: 'bimonthly',
									},
									{
										value: 'monthly',
										label: 'monthly',
									},
									{
										value: 'quarterly',
										label: 'quarterly',
									},
									{
										value: 'yearly',
										label: 'yearly',
									},
								]}
							/>
						</div>
						<div className='model-content-item'>
							<p>expireAt: </p>
							<DatePicker
								disabledDate={disabledDate}
								style={{ width: 620 }}
								showTime // 启用时间选择
								format="YYYY-MM-DD HH" // 设置日期时间格式
								placeholder="Select Date and Time"
								onChange={(value, dateString) => onChange(dateString)}
								defaultValue={momentTime}
							/>
						</div>
						{/* <div className='model-content-item'>
                    <p>expireAt: </p>
                    <DatePicker
                        disabledDate={disabledDate}
                        style={{ width: 620 }}
                        showTime // 启用时间选择
                        format="YYYY-MM-DD HH" // 设置日期时间格式
                        placeholder="Select Date and Time"
                        onChange={(value, dateString) => onChange(dateString)}
                        defaultValue={momentTime}
                    />
                </div> */}
						<div className='model-content-item'>
							<p>contact Number: </p>
							<Input style={{ width: 620 }} placeholder="contact Number"
								value={contactNumber} onChange={(e) => setContactNumber(e.target.value)} />
						</div>
						<div className='model-content-item'>
							<p>Unit Number: </p>
							<Input style={{ width: 620 }} placeholder="Unit Number"
								value={unitNumber} onChange={(e) => setUnitNumber(e.target.value)} />
						</div>
						<div className='model-content-item'>
							<p>locationId StationId: </p>
							<Input style={{ width: 620 }} placeholder="locationId StationId"
								value={locaStationId} onChange={(e) => setLocaStationId(e.target.value)} />
						</div>
						<div className='model-content-item'>
							<p>Priority: </p>
							<Select
								defaultValue="Priority"
								style={{ width: 620 }}
								onChange={handleChangePriority}
								options={[
									{
										value: 'Priority',
										label: 'Priority',
									},
									{
										value: 'regular',
										label: 'regular',
									},
								]}
							/>
						</div>
						<div className='model-content-item'>
							<p>chargePointId: </p>
							<Input style={{ width: 620 }} placeholder="chargePointId"
								value={chargePointId} onChange={(e) => setChargePointId(e.target.value)} />
						</div>
						<div className='model-content-item'>
							<p>Email address: </p>
							<Input style={{ width: 620 }} placeholder="email"
								value={email} onChange={(e) => setEmail(e.target.value)} />
						</div>
						<div className='model-last-btn'>
							<Button type="primary" danger size='large'
								style={{ margin: "10px 0", height: '50px', width: '50%', background: '#FD6B7E' }}
								onClick={() => cancelTap()}>cancel</Button>
							<Button type="primary" danger size='large'
								style={{
									background: '#FF9F39', border: '1px solid #FF9F39', height: '50px',
									width: '50%', fontSize: '20px', fontWeight: '800'
								}} onClick={() => saveTap()}>save</Button>
						</div>
					</div>
				</Modal>
			</Container>)

	);
};

export default Users;
